module.exports = __webpack_public_path__ + "static/media/HKGrotesk-Light.f8f44021.woff2";